export default {"src":"/_next/static/media/steps.73cf367f.svg","height":196,"width":1216};